<div>
  <ng-content />
</div>
<div class="flex flex-row flex-wrap gap-4">
  <ng-content select="pr-health-fund-card-preview-item" />
</div>
